import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const IterationCcw: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8' }],
    ['polyline', { points: '16 14 20 18 16 22' }],
  ],
];

export default IterationCcw;
